import { ConfigDataInterface } from './ConfigApiInterface';
import { Config_Club_PageMenu_ApiEnum } from './ClubDetailConfigApiInterface';

export enum Config_ClubMatches_ActionsMenu_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export enum Config_ClubMatches_Modules_ApiEnum {
    'indications' = 'indications',
    'overview' = 'overview',
    'matches' = 'matches',
}

export enum Config_ClubMatches_ActionsOther_ApiEnum {
    'upload_photo' = 'upload_photo',
}

export enum Config_ClubMatches_PageSubMenu_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export interface Config_ClubMatches_ApiInterface
    extends ConfigDataInterface<
        Config_ClubMatches_Modules_ApiEnum,
        Config_ClubMatches_ActionsMenu_ApiEnum,
        Config_ClubMatches_ActionsOther_ApiEnum,
        Config_Club_PageMenu_ApiEnum,
        Config_ClubMatches_PageSubMenu_ApiEnum
    > {
    _?: boolean;
}
